import React from 'react'
import { useTranslation } from 'react-i18next'
import InfoBlock from '@/routes/Quizzes/OldPortalComponents/InfoBlock'
import IconLabelButton from '@/routes/Quizzes/OldPortalComponents/IconLabelButton'

const QuizImportInstructions: React.FC = () => {
  const { t } = useTranslation('translation')

  return (
    <InfoBlock>
      {t(
        'Upload a document that includes questions. We support multiple choice questions (MCQ) and open-ended text questions.',
      )}
      <br />
      {t('For reference, you can download a')}{' '}
      <IconLabelButton
        showIcon
        iconClass="icon-download"
        buttonLabel="sample quiz template"
        useDownload
        fileSrc="https://oldportal.staging.noodlefactory.ai/static/media/sample-quiz-template.79b29ea8.docx"
      />{' '}
      {t(
        'to see an example format, but you are not required to follow it strictly.',
      )}
    </InfoBlock>
  )
}

export default QuizImportInstructions
